import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import Modal from "react-bootstrap/Modal";
import "./listadoAdministradores.scss";
import { memo, useState } from "react";
import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import ConstantesTabla from "../../../../utils/ConstantesTabla";
import ModalMensajes from "../modalMensajes/ModalMensajes";
import { borrarAdmin, getListaAdmin } from "../../../services/AdminService";
import { SpinnerCircle } from "../../../atoms/spinner/Spinner";
import FormularioAdmnistradores from "../formularioAdministradores/FormularioAdmnistradores";

registerLocale("es", es);

const ListadoAdministradores = (object) => {
  const [show, setShow] = useState({
    mensaje: false,
  });
  const [lista, setLista] = useState();
  const [loading, setLoading] = useState(false);
  const handleShow = (e) => {
    setShow(e);
  };
  const handleClose = (e) => {
    setLoading(false);
    setShow(false);
    actualizaLista();
  };
  const eliminarAdmin = (e) => {
    
    borrarAdmin(e.idadministrador).then(() => {
      setLista(
        lista.filter(
          (administrador) => administrador.idadministrador !== e.idadministrador
        )
      );
    });
  };
  const acciones = [
    {
      name: "Editar",
      center: true,
      grow: 3,
      cell: (row) => (
        <>
          <i
            className="fa-solid fa-pencil fs-3 mx-2 px-3 cursorPointer faHover"
            onClick={() => {
              setShow({ nuevo: true, usuario: row });
            }}
          ></i>
        </>
      ),
    },
    {
      name: "Borrar",
      center: true,
      grow: 1.5,
      cell: (row) => (
        <>
          <i
            className="fa-solid fa-x fs-3 mx-2 px-3 cursorPointer faHover rojo"
            onClick={() =>
              handleShow({
                mensaje: true,
                titulo: "¿Desea continuar?",
                content2:
                  "¿Está seguro que quiere eliminar a este Administrador?",
                tipo: "tituloModal",
                aviso: true,
                destinoAviso: "",
                funcion: eliminarAdmin,
                valorFuncion: row,
              })
            }
          ></i>
        </>
      ),
    },
  ];

  const actualizaLista = () => {
    getListaAdmin().then((data) => {
      setLista(data);
      setLoading(true);
    });
  };

  useEffect(() => {
    getListaAdmin().then((data) => {
      setLista(data);
      setLoading(true);
    });
  }, []);
  // const reload = () => ;

  function listadoAdministradores() {
    return (
      <>
        {show?.nuevo ? (
          <>
            <FormularioAdmnistradores
              show={show.nuevo}
              handleClose={handleClose}
              usuario={show.usuario}
            ></FormularioAdmnistradores>
          </>
        ) : (
          <Modal
            className={`infModal fechas ${show.nuevo ? "disNone" : ""}`}
            show={object.show}
            onHide={object.handleClose}
            backdrop="static"
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {/* <Titulo
                  titulo={"Editar / Eliminar Administradores"}
                  tipo={"tituloModal"}
                /> */}
                <h4 className="tituloModal">Editar / Eliminar Administradores</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="caja_formulario col-xxl-12 col-xl-12 col-lg-12 cold-md-12 cold-sm-12">
                <div className="container">
                  {loading ? (
                    <div className="row">
                      <DataTable
                        className="table-responsive"
                        columns={[
                          ...ConstantesTabla.columnasEditarAdministradores,
                          ...acciones,
                        ]}
                        data={lista}
                        pagination
                        paginationComponentOptions={
                          ConstantesTabla.paginacionOpt
                        }
                        noDataComponent={
                          <span descripcion="table-no-data-registro" />
                        }
                        customStyles={ConstantesTabla.customStyles}
                      />
                    </div>
                  ) : (
                    <SpinnerCircle></SpinnerCircle>
                  )}
                </div>
              </div>
              {show.mensaje ? (
                <ModalMensajes
                  show={show.mensaje}
                  handleClose={handleClose}
                  titulo={show.titulo}
                  tipo={show?.tipo}
                  content={show?.content}
                  content2={show?.content2}
                  contentBold={show?.contentBold}
                  otherContent={show?.otherContent}
                  aviso={show?.aviso}
                  destinoAviso={show?.destinoAviso}
                  funcion={show?.funcion}
                  valorFuncion={show?.valorFuncion}
                  funcion2={show?.funcion2}
                  valorFuncion2={show?.valorFuncion2}
                  destinoCerrar={show?.destinoCerrar}
                ></ModalMensajes>
              ) : null}
            </Modal.Body>
          </Modal>
        )}
      </>
    );
  }

  return <>{listadoAdministradores()}</>;
};

export default memo(ListadoAdministradores);
